import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCVXvBC3yX5hsxGsNopQz-HeAUaR00visM",
  authDomain: "ts-ogrenci-servis-mobile.firebaseapp.com",
  databaseURL:
    "https://ts-ogrenci-servis-mobile-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ts-ogrenci-servis-mobile",
  storageBucket: "ts-ogrenci-servis-mobile.firebasestorage.app",
  messagingSenderId: "819236724692",
  appId: "1:819236724692:web:81881ef8366743d3d0c041",
  measurementId: "G-792BJQ0KXN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
